import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useFormContext } from "react-hook-form";
import { CircularProgress } from "@mui/material";

function BrandGoals(props) {
  const { nextStep, prevStep } = props;

  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
    getValues,
  } = useFormContext();

  const brand_voice_and_tone_data = [
    { id: 1, name: "Formal or Informal", options: ["Formal", "Informal"] },
    {
      id: 2,
      name: "Friendly or Professional",
      options: ["Friendly", "Professional"],
    },
    { id: 3, name: "Humorous or Serious", options: ["Humorous", "Serious"] },
  ];

  // const [selectedGroup, setSelectedGroup] = useState(1);
  // const [selectedOption, setSelectedOption] = useState("Formal");
  const selectedOption = watch("brand_voice_and_tone");

  return (
    <>
      <div className="w-full space-y-5">
        <div className="space-y-5">
          <div className="space-y-8 mt-4">
            <div>
              <label className="text-lg text-gray-500">
                Brand Voice and Tone{" "}
                <span className="text-base">
                  (Highlight applicable option in each bullet-point)
                </span>{" "}
                *
              </label>
              <div>
                <div className="pt-2 space-y-2">
                  {brand_voice_and_tone_data.map((item, index) => (
                    <div key={index} className="flex items-center space-x-1 ">
                      <label className="text-gray-500 space-x-1 flex items-center">
                        <span
                          className={`border-[1px] border-[#6D1349] h-[10px] w-[10px] p-[1.5px] bg-white rounded-full  flex items-center justify-center`}
                        >
                          {item.options.includes(selectedOption) && (
                            <span className="bg-[#6D1349] h-full w-full rounded-full "></span>
                          )}
                        </span>

                        {item.options.map((option, index) => (
                          <div
                              key={index}
                          >
                            <span
                              onClick={() => {
                                setValue("brand_voice_and_tone", option, {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                              className={`${selectedOption === option ? "border-b-2 border-[#6D1349]" : ""} cursor-pointer `}
                            >
                              {option}
                            </span>
                            {index === 0 && (
                              <span className="capitalize font-semibold  pointer-events-none select-none">
                                {" "}OR
                              </span>
                            )}
                          </div>
                        ))}
                        {/*                      
                        <span className="capitalize font-semibold  pointer-events-none select-none">
                          OR
                        </span>
                        <span
                          onClick={() => {
                            setSelectedOption(item.options[1]);
                            setSelectedGroup(item.id);
                              setValue("brand_voice_and_tone", item.options[1]);
                          }}
                          className={`${selectedOption === item.options[1] ? "border-b-2 border-[#6D1349]" : ""} cursor-pointer`}
                        >
                          {item.options[1]}
                        </span> */}
                      </label>
                    </div>
                  ))}
                  <input
                    type="hidden"
                    {...register("brand_voice_and_tone", {
                      required: "Please select brand voice and tone.",
                    })}
                  />
                  {errors.brand_voice_and_tone && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.brand_voice_and_tone.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="text-lg text-gray-500">Brand Goals </div>
              <div className="space-y-4 mt-2">
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    Briefly describe your business or organization *
                  </div>
                  <div>
                    <textarea
                      name="business_description"
                      placeholder="Please describe your business or organization here.. "
                      rows={4}
                      {...register("business_description", {
                        required:
                          "Please briefly describe your business or organization. ",
                        validate: (v) =>
                          v.trim() !== "" ||
                          "Please briefly describe your business or organization. ",
                      })}
                      className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                    ></textarea>
                    {errors.business_description && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.business_description.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    What emotions or feelings do you want your brand to
                    evoke?{" "}
                  </div>
                  <textarea
                    placeholder="Trust, excitement, confidence, creativity, comfort, or inspiration."
                    name="brand_feelings"
                    rows={4}
                    {...register("brand_feelings")}
                    className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                  ></textarea>
                </div>
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    What are your competitors?{" "}
                  </div>
                  <textarea
                    placeholder="List your main competitors or similar brands in your industry."
                    name="competitors"
                    rows={4}
                    {...register("competitors")}
                    className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                  ></textarea>
                </div>
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    What are your brand values?{" "}
                  </div>
                  <textarea
                    placeholder="Transparency, quality, innovation, sustainability, customer-first approach."
                    name="brand_values"
                    rows={4}
                    {...register("brand_values")}
                    className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <button
            className="p-0 text-gray-500"
            onClick={() => {
              prevStep();
              if (typeof window !== "undefined") {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }
            }}
          >
            <FaArrowLeftLong />
          </button>
          <button
            className=" bg-[#FFC067] font-bold  rounded px-6 py-3 text-base md:text-lg hover:bg-[#DF73FF]  transition ease-in duration-300 cursor-pointe text-dark "
            onClick={async () => {
              const isValid = await trigger([
                "brand_voice_and_tone",
                "business_description",
              ]);
              if (isValid) {
                nextStep();
              }
              if (typeof window !== "undefined") {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }
            }}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}

export default BrandGoals;
